// export const cardData = [
//     {id:1, name:"Թեմայի անվանումը",info:"Դիտել", file:  `${window.location.origin}/files/բկծ.pdf`},
// ];
// export const materialsCardData = [
//     {id: 1, name: "Ինֆորմատիկա Թեմայի անվանումը", info: "Դիտել", file: "../../files/բկծ.pdf", menuItemId: 1},
//
//
// ];
//
// export const videoCardData = [
//     {id: 1, name: "Ինֆորմատիկա վիդեո Թեմայի անվանումը", info: "Դիտել", file: "../../files/բկծ.pdf", menuItemId: 1},
//
// ]
//
// export const testCardData = [
//     {id: 1, name: "Ինֆորմատիկա Թեմայի անվանումը", info: "Դիտել", file: "../../files/բկծ.pdf", menuItemId: 1},
//
//
// ];
//
//
//
// const filterByMenuItemId = (dataArray, menuItemId) => {
//     return dataArray.filter(item => item.menuItemId === menuItemId);
// }
//
// export const handlerContentData = ( subcategory, menuItemId ) => {
//     switch ( subcategory ) {
//         case "Որակավորման քննություններ":
//             return filterByMenuItemId(videoCardData, menuItemId )
//         case "Թեստեր":
//             return filterByMenuItemId(testCardData, menuItemId )
//         default:
//             return filterByMenuItemId(materialsCardData, menuItemId )
//     }
// }
import {informMaterials} from "../information/utils";
import {technologyMaterials} from "../technology/utils";
import {chemistryMaterials} from "../chemistry/utils";
import {biologyMaterials} from "../biology/utils";
import {physicsMaterials} from "../physics/utils";
import {geographyMaterials} from "../geography/utils";
import {mathematicsMaterials} from "../mathematics/utils";



// const filterByMenuItemId = (array, menuItemId) => array.filter(item => item.menuItemId === menuItemId);
const findByMenuItemId = (menuItemId) => {
    return (
        informMaterials.find(item => item.menuItemId === menuItemId) ||
        technologyMaterials.find(item => item.menuItemId === menuItemId) ||
        physicsMaterials.find(item => item.menuItemId === menuItemId) ||
        chemistryMaterials.find(item => item.menuItemId === menuItemId) ||
        biologyMaterials.find(item => item.menuItemId === menuItemId) ||
        geographyMaterials.find(item => item.menuItemId === menuItemId) ||
        mathematicsMaterials.find(item => item.menuItemId === menuItemId)
    );
};
export const handlerContentData = (subcategory, menuItemId) => {
    const source = findByMenuItemId(menuItemId);

    if (!source) return [];

    switch (subcategory) {
        case "Տեսական Նյութեր":
        case "Լաբորատոր աշխատանքներ":
            return source.materials || [];
        case "Տեսանյութեր":
            return source.video || [];
        case "Հղումներ":
            return source.links || [];
        case "Այլ":
            return source.tests || [];
        default:
            return [];
    }
};

